import { getMiningStatus_2 } from '../../../Services/Requests';

export class FetchMiningDataService {
  static async fetch() {
    try {
      const response = await getMiningStatus_2();
      return response;
    } catch (error) {
      console.error("Ошибка при получении данных майнинга:", error);
      throw error;
    }
  }
}